import { useState } from 'react';
import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';

import {
  withDividers,
  withHtml,
  withInlines,
  withLists,
  withNewLine,
  withNormalizedPlaceholder,
  withParagraphs,
  withPreviousSelection,
  withPromptTags,
  withVariationBlocks,
} from './plugins';
import { applyPlugins } from './utils';

const PLUGINS = [
  withReact,
  withHistory,
  withLists,
  withParagraphs,
  withHtml,
  withDividers,
  withNormalizedPlaceholder,
  withNewLine,
  withVariationBlocks,
  withInlines,
  withPreviousSelection,
  withPromptTags,
];

/**
 * Create Slate editor instance with plugins
 * @param {object} [options] - editor options
 * @param {SLATE_TEXT_FORMATS} [options.defaultTextFormat] - default text format
 * @returns {*}
 */
export const useRichSlateEditor = (options = undefined) => {
  const [editor] = useState(() => applyPlugins(createEditor(), PLUGINS, options));
  return editor;
};
